/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AdminStockAdjustLocationMoveResVo } from './AdminStockAdjustLocationMoveResVo';
import {
    AdminStockAdjustLocationMoveResVoFromJSON,
    AdminStockAdjustLocationMoveResVoFromJSONTyped,
    AdminStockAdjustLocationMoveResVoToJSON,
    AdminStockAdjustLocationMoveResVoToJSONTyped,
} from './AdminStockAdjustLocationMoveResVo';

/**
 * 
 * @export
 * @interface ResponseAdminStockAdjustLocationMoveResVo
 */
export interface ResponseAdminStockAdjustLocationMoveResVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseAdminStockAdjustLocationMoveResVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseAdminStockAdjustLocationMoveResVo
     */
    message?: string;
    /**
     * 
     * @type {AdminStockAdjustLocationMoveResVo}
     * @memberof ResponseAdminStockAdjustLocationMoveResVo
     */
    data?: AdminStockAdjustLocationMoveResVo;
}

/**
 * Check if a given object implements the ResponseAdminStockAdjustLocationMoveResVo interface.
 */
export function instanceOfResponseAdminStockAdjustLocationMoveResVo(value: object): value is ResponseAdminStockAdjustLocationMoveResVo {
    return true;
}

export function ResponseAdminStockAdjustLocationMoveResVoFromJSON(json: any): ResponseAdminStockAdjustLocationMoveResVo {
    return ResponseAdminStockAdjustLocationMoveResVoFromJSONTyped(json, false);
}

export function ResponseAdminStockAdjustLocationMoveResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseAdminStockAdjustLocationMoveResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : AdminStockAdjustLocationMoveResVoFromJSON(json['data']),
    };
}

export function ResponseAdminStockAdjustLocationMoveResVoToJSON(json: any): ResponseAdminStockAdjustLocationMoveResVo {
    return ResponseAdminStockAdjustLocationMoveResVoToJSONTyped(json, false);
}

export function ResponseAdminStockAdjustLocationMoveResVoToJSONTyped(value?: ResponseAdminStockAdjustLocationMoveResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': AdminStockAdjustLocationMoveResVoToJSON(value['data']),
    };
}

